export enum Permissions {
    CanViewAllRecords = 'View all records',
    CanViewPublishedRecords = 'View published records',
    CanViewObsoleteRecords = 'View obsolete records',
    CanViewEOLRecords = 'View eol records',
    CanViewDraftRecords = 'View draft records',
    CanViewCancelledRecords = 'View cancelled records',
    CanViewReviewRecords = 'View review records',
    CanViewApprovedRecords = 'View approved records',
    CanViewLicenseCostData = 'View license cost data',
    CanViewOdrlTab = 'View ODRL Tab',
    CanViewSupplierContactsData = 'View supplier contacts data',
    CanEdit = 'Edit',
    CanCreate = 'Create',
    CanCreateCleanse = 'Can Create Cleanse',
    CanClone = 'Clone',
    CanDelete = 'Delete',
    CanPublish = 'Publish',
    CanClose = 'Close'
}
